import React, {useState} from "react";
import $ from "jquery";
import I18n from 'i18n.js.erb';
import VacationModeModal from "./VacationModeModal";

function handleOpenVacationModeModal() {
  $('#vacationModeModal').modal()
}

const VacationMode = ({user}) => {

  return (
    <React.Fragment>
      <a id="vacation_mode_link" className="nav-link active text-dark cursor-pointer"
         onClick={handleOpenVacationModeModal}>
        <i className="fas fa-umbrella-beach mr-3"></i>
        {I18n.t('js.profilePage.vacationMode')} {user.on_vacation ? 'ON' : 'OFF'}
      </a>
      <VacationModeModal user={user}/>
    </React.Fragment>
  );
}

export default VacationMode;
